import React, { useState } from "react";
import { Box } from "@mui/material";

/**
 * Shows the thumbnail as an overlay whenever the video is paused — a plain
 * <video poster> only displays before the FIRST play; once you've played
 * and paused, browsers show the last frame instead of going back to the
 * poster. Mirrors QueuePreview.js ("Video Queue"), which solves this the
 * same way for its own preview player.
 */
export default function VideoPlayer({ src, poster, ...rest }) {
  const [isPaused, setIsPaused] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);

  return (
    <Box sx={{ position: "relative", bgcolor: "black", lineHeight: 0, borderRadius: 1, overflow: "hidden" }}>
      <Box
        component="video"
        src={src}
        controls
        poster={poster || undefined}
        onPlay={() => { setHasStarted(true); setIsPaused(false); }}
        onPause={() => setIsPaused(true)}
        sx={{ width: "100%", maxHeight: "60vh", display: "block", outline: "none" }}
        {...rest}
      />
      {poster && isPaused && hasStarted && (
        <Box
          component="img"
          src={poster}
          alt=""
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "calc(100% - 38px)", // match video height, leave controls row visible
            objectFit: "contain",
            bgcolor: "black",
            pointerEvents: "none",
          }}
        />
      )}
    </Box>
  );
}
